"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Option = _lib.Mentions.Option;
function ArcMentions(props) {
  var options = props.options,
    displayKey = props.displayKey,
    id = props.id,
    showArrow = props.showArrow,
    placeholder = props.placeholder,
    loading = props.loading,
    dropdownStyle = props.dropdownStyle,
    placement = props.placement,
    onClear = props.onClear,
    onBlur = props.onBlur,
    onSearch = props.onSearch,
    status = props.status,
    onChange = props.onChange,
    className = props.className,
    onFocus = props.onFocus,
    disabled = props.disabled;
  var display = displayKey ? displayKey : 'name';
  var key = id ? id : display;
  return /*#__PURE__*/_react["default"].createElement(_lib.Mentions, {
    disabled: disabled,
    showSearch: true,
    dropdownClassName: className,
    dropdownStyle: dropdownStyle,
    style: {
      width: '100%'
    },
    placeholder: placeholder ? placeholder : '',
    onChange: onChange,
    loading: loading,
    onFocus: onFocus && onFocus,
    placement: placement,
    onBlur: onBlur && onBlur,
    onClear: onClear,
    status: status,
    showArrow: showArrow ? showArrow : false,
    onSearch: onSearch
  }, options.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: item[key],
      value: item[display]
    }, item[display]);
  }));
}
var _default = ArcMentions;
exports["default"] = _default;